import { getBrandLogoSrc } from '../core/brand-logo';

export function AuthLogo({ size = 72, style = {} }) {
  return (
    <img
      src={getBrandLogoSrc()}
      alt="Founders Bridge"
      style={{
        width: size,
        height: size,
        objectFit: 'contain',
        margin: '0 auto 12px',
        display: 'block',
        ...style,
      }}
    />
  );
}

export function BrandLogo({ size = 40, className, style = {} }) {
  return (
    <img
      src={getBrandLogoSrc()}
      alt="Founders Bridge"
      className={className}
      style={{ width: size, height: size, objectFit: 'contain', ...style }}
    />
  );
}
